import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Button as MuiButton } from '@mui/material';
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function EditQuadrant() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [tabs, setTabs] = useState([]);
  const [quadrant, setQuadrant] = useState({
    tab: "",
    index: "",
    name: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // fetch tabs
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/tabs`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => setTabs(data))
      .catch(console.error);

    // fetch this quadrant
    axios
      .get(`${process.env.REACT_APP_BASE_URL}common/quadrants/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => {
        setQuadrant({
          tab: typeof data.tab === "object" ? data.tab._id : data.tab,
          index: data.index,
          name: data.name
        });
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [id]);

  const updateQuadrant = async () => {
    const { tab, index, name } = quadrant;
    if (!tab || !index || !name) {
      alert("Tab, Index & Name are required.");
      return;
    }
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}common/quadrants/${id}`,
        quadrant,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Quadrant updated successfully!");
      navigate("/quadrant-list");
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.message || "Error updating quadrant.");
    }
  };

  if (loading) return <PageLayout><p>Loading…</p></PageLayout>;

  return (
    <PageLayout>
      <Grid container spacing={3} alignItems="center" sx={{ mb: 3 }}>
        <Grid size="auto"><Breadcrumb title="Edit Quadrant" /></Grid>
        <Grid size="auto" sx={{ ml: "auto", textAlign: "right" }}>
          <Link to="/quadrant-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>

      <Box className="mc-card">
        <Grid container spacing={3}>
          {/* Tab */}
          <Grid size={12} sx={{ mb: 3 }}>
            <CardHeader title="Tab" />
            <TextField
              select
              fullWidth
              value={quadrant.tab}
              onChange={e => setQuadrant({ ...quadrant, tab: e.target.value })}
            >
              {tabs.map(t => (
                <MenuItem key={t._id} value={t._id}>
                  {t.name} (Index: {t.index})
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Quadrant Index */}
          <Grid size={12} sx={{ mb: 3 }}>
            <CardHeader title="Quadrant Index" />
            <TextField
              type="number"
              fullWidth
              value={quadrant.index}
              onChange={e => setQuadrant({ ...quadrant, index: e.target.value })}
            />
          </Grid>

          {/* Quadrant Name */}
          <Grid size={12} sx={{ mb: 3 }}>
            <CardHeader title="Quadrant Name" />
            <TextField
              fullWidth
              value={quadrant.name}
              onChange={e => setQuadrant({ ...quadrant, name: e.target.value })}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Grid size="auto" sx={{ ml: "auto", textAlign: "right" }}>
            <MuiButton variant="contained" color="primary" onClick={updateQuadrant}>
              Save Changes
            </MuiButton>
          </Grid>
        </Grid>
      </Box>
    </PageLayout>
  );
}
